import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import { StyleSheet } from "@react-pdf/renderer";

import VoTheme from "ui/theme/vocollege2";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      flexDirection: "column",
    },
    wrapper: {
      border: `3px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadiusBig,
      flex: 1,
      maxWidth: "100%",
      paddingTop: "10%",
      position: "relative",
      textAlign: "center",
    },
    title: {},
    name: {},
    personalNumber: {},
    row: {},
    signatures: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      paddingLeft: VoTheme.spacing(7),
      paddingRight: VoTheme.spacing(7),
      width: "100%",
    },
    signature: {
      borderTop: `1px solid ${VoTheme.palette.common.black}`,
      flex: 1,
      marginLeft: VoTheme.spacing(1),
      marginRight: VoTheme.spacing(1),
      maxWidth: 250,
    },
    signaturePerson: {},
    signatureTitle: {},
    footer: {
      border: "1px solid red",
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
    },
  })
);

export const styles = StyleSheet.create({
  page: {
    fontFamily: "EB Garamond",
    // fontSize: 15,
    padding: VoTheme.spacing(4),
  },
  decor: {
    border: `5px solid ${VoTheme.palette.secondary.main}`,
    borderTopLeftRadius: VoTheme.shape.borderRadiusBig,
    borderTopRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomRightRadius: VoTheme.shape.borderRadiusBig,
    borderBottomLeftRadius: VoTheme.shape.borderRadiusBig,
    height: "100%",
    // paddingLeft: VoTheme.spacing(10),
    // paddingRight: VoTheme.spacing(10),
    padding: `${VoTheme.spacing(2)} ${VoTheme.spacing(8)}`,
    width: "100%",
  },
  title: {
    color: VoTheme.palette.grey[500],
    fontSize: 48,
    fontWeight: 700,
    textAlign: "center",
    textTransform: "uppercase",
  },
  subtitle: {
    color: VoTheme.palette.grey[500],
    fontSize: 24,
    fontWeight: 700,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  person: {
    fontSize: 24,
    fontStyle: "italic",
    fontWeight: 500,
    textAlign: "center",
  },
  personalNumber: {
    fontSize: 12,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  text: {
    fontSize: 16,
    textAlign: "center",
  },
  signatures: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  signature: {
    borderTop: `1px solid ${VoTheme.palette.common.black}`,
    flex: 1,
    marginLeft: VoTheme.spacing(2),
    marginRight: VoTheme.spacing(2),
    maxWidth: 250,
  },
  signaturePerson: {
    fontSize: 16,
    textAlign: "center",
  },
  signatureTitle: {
    fontSize: 16,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  logoWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  logo: {
    marginTop: VoTheme.spacing(4),
    height: 240,
    width: 100,
  },
  educator: {
    fontSize: 16,
    marginTop: VoTheme.spacing(3),
    textAlign: "center",
  },
  place: {
    fontSize: 16,
    textAlign: "center",
  },
  date: {
    fontSize: 16,
    marginTop: VoTheme.spacing(1),
    textAlign: "center",
  },
  footer: {
    marginTop: VoTheme.spacing(15),
  },
  educatorCertified: {
    fontSize: 16,
    marginTop: VoTheme.spacing(4),
    textAlign: "center",
  },
  uid: {
    position: "absolute",
    right: VoTheme.spacing(3),
    top: 0,
  },
});
